// The parts of the 3D engine (Game.ts, Cue.ts) the frame controller uses, as typed interfaces.
//
// Match and its modules don't import Game or Cue: Game.ts binds them here when it loads (bindEngine at the end of
// Game.ts), which breaks the Match -> Game -> Match and Match -> Cue -> Match import cycles. Game.ts and Cue.ts
// themselves are unchanged (still `any` inside); this only types what Match touches.
import type {StrokeTracker} from "../stroke";

export interface CameraView {
    horizontalAngle: number;
    verticalAngle: number;
}

export interface GameView {
    /** undefined until Game.InitCamera */
    Camera: CameraView;
}

export interface Velocity { x: number; y: number }

export interface CueView {
    Enabled: boolean;
    Distance: number;
    StrokeActive: boolean;
    Tracker: StrokeTracker;
    /** the cue's three.js object (an empty object until its model has loaded) */
    RenderedBody: {position?: {y: number}} | null | undefined;
    Shot(velocity: Velocity): void;
    SendShot(velocity: Velocity): void;
}

export interface Engine {
    readonly game: GameView;
    readonly cue: CueView;
}

let bound: Engine | null = null;

export function bindEngine(engine: Engine) {
    bound = engine;
}

/** Game.ts binds the engine when its module loads, before any socket message or frame can arrive. */
export function engine(): Engine {
    if (!bound) throw new Error("Match: engine not bound (Game.ts binds it on load)");
    return bound;
}
